module.exports = __webpack_public_path__ + "img/popup-guest-tab.274180e5.svg";